/**
 * @generated SignedSource<<eb9edff2c8ed43e53b000446d23a8e7a>>
 * @relayHash d90ec097d86f2f96319ab37c8c32fd48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 89ae0bec5a88ba1cbf93cca7fec9ea3efc6d85ddd451faad35bce28f65089fb0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type StatuspageDetailsPageDraftQuery$variables = {
  pageId: string;
};
export type StatuspageDetailsPageDraftQuery$data = {
  readonly stakeholderComms_getDraftPageById: {
    readonly error: string | null | undefined;
    readonly page: {
      readonly name: string;
      readonly " $fragmentSpreads": FragmentRefs<"StatuspageDraftDetails">;
    } | null | undefined;
  } | null | undefined;
};
export type StatuspageDetailsPageDraftQuery = {
  response: StatuspageDetailsPageDraftQuery$data;
  variables: StatuspageDetailsPageDraftQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pageId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "pageId",
    "variableName": "pageId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "error"
},
v3 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "StatuspageDetailsPageDraftQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getDraftPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "StatuspageDraftDetails"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StatuspageDetailsPageDraftQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "StakeholderCommsPageResponse",
        "kind": "LinkedField",
        "name": "stakeholderComms_getDraftPageById",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "concreteType": "StakeholderCommsPage",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "domain"
              },
              {
                "kind": "ScalarField",
                "name": "description"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "89ae0bec5a88ba1cbf93cca7fec9ea3efc6d85ddd451faad35bce28f65089fb0",
    "metadata": {},
    "name": "StatuspageDetailsPageDraftQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9be7e1b8ce7d4f0c842a512e838b8673";

export default node;
